import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { goToCheckout, scrollToOffer } from '../utils/scroll';
interface CtaButtonProps {
  children: React.ReactNode;
  action?: 'checkout' | 'scroll';
  size?: 'md' | 'lg' | 'xl';
  pulse?: boolean;
  className?: string;
  withArrow?: boolean;
}
const SIZES: Record<'md' | 'lg' | 'xl', string> = {
  md: 'text-base py-4 px-8 rounded-full',
  lg: 'text-lg sm:text-xl py-5 px-8 sm:px-10 rounded-full',
  xl: 'text-xl sm:text-2xl py-6 px-8 rounded-2xl'
};
export function CtaButton({
  children,
  action = 'scroll',
  size = 'lg',
  pulse = false,
  className = '',
  withArrow = true
}: CtaButtonProps) {
  return <button type="button" onClick={action === 'checkout' ? goToCheckout : scrollToOffer} className={`inline-flex items-center justify-center gap-3 bg-coral hover:bg-coral-oscuro text-white font-bold tracking-wide shadow-lg transition-colors duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40 ${SIZES[size]} ${pulse ? 'animate-cta' : ''} ${className}`} data-id="element-31" data-mp="10c7sqeu83zto">
      <span data-id="element-32" data-mp="39yhn1mmcjfbq">{children}</span>
      {withArrow && <ArrowRightIcon className="w-5 h-5 shrink-0" aria-hidden="true" data-id="element-33" data-mp="39zj3k6m4su0u" />}
    </button>;
}